export default __webpack_public_path__ + "static/media/status-warning.79436b27.svg";